<template>
  <div class="start-plan-container fill-height pt-12">
      <v-row justify="center">
        <v-col cols="12" md="8" lg="6" class="text-center">
          <!-- Logo SeleAI -->
          <div class="logo-container mb-6">
            <div class="logo-circle">
              <!-- <span class="logo-text">S</span> -->

              <v-img 
            src="../../assets/logo.png"
            max-width="56"
            contain
            class="logo-image"
          ></v-img>

            </div>
          </div>
  
          <h1 class="font-weight-bold mb-4">
            ¡Bienvenido a <span class="gradient-text">SeleAI</span>!
          </h1>
          
          <p class="subtitle-1 mb-8">
            Aquí tienes una oferta exclusiva, ¡solo para ti!
          </p>

          <!-- Código promocional -->
          <v-alert
          v-if="false"
            color="primary"
            class="promo-code-alert mb-8"
            dense
            outlined
            shaped
          >
            <div class="d-flex justify-space-between align-start d-flex flex-wrap">
              <div class="d-flex align-center">
                <v-icon small class="mr-2">mdi-ticket-percent</v-icon>
                <span class="font-weight-medium">Usa el código <code>sele-50</code> para un 50% de descuento en todos los planes!</span>
              </div>
              <div class="timer-chip">
                <v-icon x-small class="mr-1">mdi-clock-outline</v-icon>
                Solo para los primeros 20
              </div>
            </div>
          </v-alert>
        </v-col>
      </v-row>
    
    <!-- Componente de Precios -->
    <pricing-section :billing-type="billingType" :is-start-plan="true" />
    
    <!-- Enlace para continuar con cuenta gratuita -->
    <div class="text-center mt-8 pb-12">
      <router-link to="/app" class="free-account-link">
        O continuar con una cuenta gratuita <v-icon small>mdi-chevron-right</v-icon>
      </router-link>
    </div>
  </div>
</template>

<script>
import PricingSection from '@/components/pricing/PricingSection.vue'

export default {
  name: 'StartPlan',
  components: {
    PricingSection
  },
  data() {
    return {
      billingType: 'annually',
      expirationTime: '2:59:44',
      timer: null
    }
  },
  mounted() {
    if (this.$root.currentUser && this.$root.currentUser.premium) {
      this.$router.push('/app');
    }

    // Iniciar temporizador de cuenta regresiva
    this.startCountdown();
  },
  beforeDestroy() {
    // Limpiar temporizador al destruir componente
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    startCountdown() {
      // Establecer tiempo inicial (48 horas en segundos)
      let totalSeconds = 48 * 60 * 60;
      
      this.timer = setInterval(() => {
        totalSeconds--;
        
        if (totalSeconds <= 0) {
          clearInterval(this.timer);
          totalSeconds = 0;
        }
        
        // Calcular horas, minutos y segundos
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        
        // Formatear tiempo
        this.expirationTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      }, 1000);
    }
  }
}
</script>

<style scoped>
.start-plan-container {
  background: linear-gradient(135deg, #f8feff, #f5f9f5);
  min-height: 100vh;
  font-family: "Nunito", "DINRounded", "Inter", sans-serif !important;
}

h1 {
  font-size: 2.5rem;
  line-height: 1.2;
  color: #333 !important;
}

.subtitle-1 {
  color: #555;
  font-size: 1.1rem;
}

.gradient-text {
  background: linear-gradient(90deg, #4dd453, #4fee57);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 900;
}

.logo-container {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.logo-circle {
  width: 80px;
  height: 80px;
  background-color: #f0f9f0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(77, 212, 83, 0.2);
}

.logo-text {
  font-size: 36px;
  font-weight: 900;
  background: linear-gradient(90deg, #4dd453, #4fee57);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.billing-toggle {
  background-color: #f0f9f0 !important;
  border-radius: 16px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  overflow: hidden !important;
}

.billing-toggle .v-btn {
  background-color: transparent !important;
  height: 46px !important;
  letter-spacing: 0 !important;
  text-transform: none !important;
  font-weight: 600 !important;
  color: #4b4b4b !important;
  border: none !important;
}

.billing-toggle .v-btn.v-item--active {
  background-color: #4dd453 !important;
  color: white !important;
  box-shadow: 0 2px 5px rgba(77, 212, 83, 0.3) !important;
}

.discount-chip {
  background-color: white;
  color: #4dd453;
  font-size: 0.7rem;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 100px;
  margin-left: 8px;
  display: inline-block;
}

.v-btn.v-item--active .discount-chip {
  background-color: rgba(255, 255, 255, 0.95);
  color: #4dd453;
}

.promo-code-alert {
  border-radius: 12px !important;
  background-color: #f0f9f0 !important;
  border-color: #4dd453 !important;
  color: #4b4b4b !important;
}

.promo-code-alert code {
  background-color: rgba(77, 212, 83, 0.1);
  color: #4dd453;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 600;
}

.timer-chip {
  background-color: white;
  padding: 4px 8px;
  border-radius: 100px;
  font-size: 0.8rem;
  font-weight: 500;
  color: #666;
  display: flex;
  align-items: center;
}

.free-account-link {
  color: #b2b2b2;
  font-weight: 600;
  text-decoration: none;
  font-size: 1rem;
  display: inline-flex;
  align-items: center;
}

.free-account-link:hover {
  text-decoration: underline;
}
</style>
